import { EOutputAnalysisType } from "./spatial";

// CountryCode "Global" could sometimes be represented by an empty string, but they are equivalent
export type CountryCode = "global" | "" | "id" | "my" | "vn" | "jp";

export type Source = "bvt" | "user";

export enum EspatialAggregationType {
  H3 = "H3",
  GEOHASH = "geohash"
}

export type SpatialAttributeType = {
  POI: "poi";
  POLYGON: "polygon";
  ADM_AREA: "adm_area";
  GRID: EOutputAnalysisType.GRID;
  PROFILING: EOutputAnalysisType.PROFILING;
  H3: "H3";
  GEOHASH: "geohash";
  LINE: "line";
};

export interface AttributeValuesFilterPayload {
  id: string;
  filter: string[];
}

export type SpatialAggregationType =
  | "poi"
  | "polygon"
  | "adm_area"
  | EOutputAnalysisType.GRID
  | EOutputAnalysisType.PROFILING
  | "H3"
  | "geohash"
  | "line";

// "default" represents the fallback state for invalid or empty aggregation values in spatial aggregation.
export type ExtendedSpatialAggregationType = "default" | SpatialAggregationType;

export type Pagination = {
  next: number;
  per_page: number;
  prev: number;
  total: number;
  total_pages: number;
};

export type ColorVariant =
  | 900
  | 800
  | 700
  | 600
  | 500
  | 400
  | 300
  | 200
  | 100
  | 50;

export interface PropertyValue {
  value: string | number;
  type: "string" | "int" | "float";
}

export interface OrdinalColorCategory {
  category: string;
  color: number;
}

export type OrdinalRange = { category: string; color: number };

export const TOOLTIP_TRIGGER_LENGTH = 29; // width content 200px : 7 = 28.57, rounded to 29

export type PrimitiveDisplayValue =
  | string
  | number
  | boolean
  | null
  | undefined;
